import React from 'react';

interface TabSwitchProps {
  activeTab: 'active' | 'archived';
  setActiveTab: (tab: 'active' | 'archived') => void;
  className?: string;
}

export const TabSwitch: React.FC<TabSwitchProps> = ({
  activeTab,
  setActiveTab,
  className = ""
}) => {
  return (
    <div className={`flex space-x-1 bg-gray-100 dark:bg-gray-700 rounded-xl p-1 ${className}`}>
      <button
        onClick={() => setActiveTab('active')}
        className={`flex-1 px-4 py-1 rounded-lg text-sm font-medium transition-all duration-200 ${
          activeTab === 'active'
            ? 'bg-white dark:bg-gray-600 text-gray-900 dark:text-white shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
        }`}
      >
        Active
      </button>
      <button
        onClick={() => setActiveTab('archived')}
        className={`flex-1 px-4 py-1 rounded-lg text-sm font-medium transition-all duration-200 ${
          activeTab === 'archived'
            ? 'bg-white dark:bg-gray-600 text-gray-900 dark:text-white shadow-sm'
            : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
        }`}
      >
        Archived
      </button>
    </div>
  );
};

export default TabSwitch;
